module.exports = __webpack_public_path__ + "b9964c1a3e377b0e98c147e34ec5dcad.pdf";